var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertTri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 234,
    viewBox: "0 0 270 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4789 196.309L114.228 12.6397C118.592 5.40402 126.551 0.908936 135.001 0.908936C143.45 0.908936 151.409 5.40401 155.773 12.6402L266.522 196.309C271.031 203.788 271.165 213.158 266.871 220.762C262.576 228.367 254.483 233.09 245.75 233.09H24.251C15.5182 233.09 7.42502 228.367 3.1298 220.762C-1.16436 213.157 -1.03095 203.787 3.4789 196.309ZM18.4365 212.118C19.6188 214.211 21.8468 215.512 24.251 215.512H245.75C248.154 215.512 250.382 214.212 251.564 212.119C252.746 210.025 252.709 207.445 251.469 205.387L140.719 21.7174C139.517 19.7256 137.326 18.4879 135 18.4879C132.674 18.4879 130.483 19.7256 129.282 21.7174L18.533 205.387C17.2911 207.446 17.2542 210.025 18.4365 212.118Z",
    fill: "#FF8A35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 73.2332C141.606 73.2332 146.824 76.8212 146.824 83.182C146.824 102.589 144.541 130.477 144.541 149.885C144.541 154.941 140.137 157.061 134.918 157.061C131.004 157.061 125.459 154.941 125.459 149.885C125.459 130.478 123.176 102.59 123.176 83.182C123.176 76.8217 128.558 73.2332 134.919 73.2332Z",
    fill: "#FF8A35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.755 168.314C141.93 168.314 147.313 174.022 147.313 180.872C147.313 187.559 141.931 193.43 134.755 193.43C128.068 193.43 122.36 187.559 122.36 180.872C122.36 174.022 128.069 168.314 134.755 168.314Z",
    fill: "#FF8A35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTri);
export default __webpack_public_path__ + "static/media/alert-tri.ebda433bb5b947db4c033fca3c5724e1.svg";
export { ForwardRef as ReactComponent };